import React, { useState } from "react";

import { useLocation, Navigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import APIService from "../Services/API/APIService";
import {
  Form,
  Input,
  Button,
  Card,
  Grid,
  Dimmer,
  Loader,
  Message,

} from "semantic-ui-react";
import CooperatorsAuth from "../Services/API/CooperatorsAuth";
import Navbar from "../Components/NavHeader";
const Login = (props) => {
  const [redirectToReferrer, setRedirectToReferrer] = useState(false);
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "" });
  const [token, setToken] = useState(null);
  const [view, setView] = useState("LOGIN");
  const location = useLocation()


  const schema = Yup.object().shape({
    username: Yup.string().required("Required"),
    password: Yup.string().required("Required"),
  });

  const schema2 = Yup.object().shape({
    code: Yup.string().required("Required"),
  });

  let { from } = location.state || { from: { pathname: "/" } };

  var is_valid_email = function (email) {
    return /^.+@.+\..+$/.test(email);
  };

  const _login = async (credentials) => {
    try {
      setLoading(true);
      setAlert({ show: false, message: "" });

      let response = null;

      if (is_valid_email(credentials.username)) {
        response = await APIService.postDataNoAuth("/auth/guesthouse-login", credentials);
      } else {
        let response = null
        response = await CooperatorsAuth.login(credentials);
        setLoading(false);

        if (response.user.secondFactorEnabled) {
          setToken(response.token);
          setLoading(false);
          setView("2FA");
          return;
        } else {
          response = await APIService.postDataNoAuth("/auth/coop", response);
        }
      }
      setLoading(false)
      afterLogin(response);
    } catch (error) {
      console.log("error", error);
      setAlert({ show: true, message: "Login failed" });
      setLoading(false);
    }
  };

  const _verifyCode = async (payload) => {
    try {
      setLoading(true);
      setAlert({ show: false, message: "" });

      let response = await CooperatorsAuth.verifyCode(payload, token);

      setLoading(false);

      if (response) {
        response = await APIService.postDataNoAuth("/auth/coop-guest", response);
        afterLogin(response);
      } else {
        setAlert({ show: true, message: "Incorrect code" });
      }
    } catch (error) {
      setLoading(false);
      setAlert({ show: true, message: "Incorrect code" });
      console.log("error", error);
    }
  };

  const afterLogin = async (loginResponse) => {
    if (!loginResponse) {
      setAlert({ show: true, message: "Login failed" });
      return;
    }

    APIService.storeToken(loginResponse.token);
    setRedirectToReferrer(true);

  };

  if (redirectToReferrer) {
    return <Navigate to={from} replace />

  }

  return (
    <div>
      <Navbar />
      {loading && (
        <Dimmer active inverted>
          <Loader > Authenticating User...  </Loader>
        </Dimmer>
      )}

      <Grid centered >


        {alert?.show && (
          <Card centered>

            <Message negative>
              <p style={{ fontSize: '1.12em' }}>{alert.message}</p>
            </Message>
          </Card>
        )}

        <Grid.Row>
          <Grid stackable relaxed="very">
            <Grid.Row>
              <Grid.Column verticalAlign="middle">
                {view === "LOGIN" && (
                  <Card centered>

                    <Card.Content>
                      <Formik
                        initialValues={{
                          username: "",
                          password: "",
                        }}
                        validationSchema={schema}
                        onSubmit={(values) => _login(values)}
                      >
                        {(props) => {
                          const {
                            values,
                            handleChange,
                            handleSubmit,
                            errors,
                            touched,
                          } = props;
                          return (
                            <Form onSubmit={handleSubmit}>

                              <Grid>
                                <Grid.Row>
                                  <Grid.Column>
                                    <Input
                                      style={{ width: "100%", borderColor: 'green' }}
                                      name="username"
                                      placeholder="Enter IGG or email"
                                      values={values.username}
                                      onChange={handleChange}
                                      error={
                                        errors.username && touched.username
                                      }
                                    />
                                  </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                  <Grid.Column>
                                    <Input
                                      style={{ width: "100%" }}
                                      type="password"
                                      name="password"
                                      placeholder="Enter password"
                                      values={values.password}
                                      onChange={handleChange}
                                      error={
                                        errors.password && touched.password
                                      }
                                    />
                                  </Grid.Column>
                                </Grid.Row>
                                <Grid.Row>
                                  <Grid.Column>
                                    <Button type="submit" style={{ backgroundColor: '#26f09e', color: '#000000' }}  >
                                      Login
                                    </Button>
                                    <Button style={{ backgroundColor: '#26f09e', color: '#000000' }} as={'a'} href='forgotpassword'> Forgot password </Button>
                                  </Grid.Column>
                                </Grid.Row>
                              </Grid>
                            </Form>
                          );
                        }}
                      </Formik>{" "}



                    </Card.Content>
                  </Card>
                )}

                {view === "2FA" && (
                  <Card centered>
                    <Card.Content>
                      <Card.Meta style={{ color: "#00008b", fontSize: '1.25em' }}>
                        Fill in the 6 digit code sent to you
                      </Card.Meta>
                    </Card.Content>
                    <Card.Content>
                      <Formik
                        initialValues={{
                          code: "",
                        }}
                        validationSchema={schema2}
                        onSubmit={(values) => _verifyCode(values)}
                      >
                        {(props) => {
                          const {
                            values,
                            handleChange,
                            handleSubmit,
                            errors,
                            touched,
                          } = props;
                          return (
                            <Form onSubmit={handleSubmit}>
                              <Form.Input
                                name="code"
                                placeholder="Enter code"
                                values={values.code}
                                onChange={handleChange}
                                error={errors.code && touched.code}
                              />
                              <Button type="submit" style={{ backgroundColor: '#26f09e', color: '#000000' }}  >
                                Verify
                              </Button>
                            </Form>
                          );
                        }}
                      </Formik>
                    </Card.Content>
                    <Card.Content>
                      <div onClick={() => setView("LOGIN")}> Retry Login </div>
                    </Card.Content>
                  </Card>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Grid.Row>
      </Grid>

    </div>
  );
};

export default Login;
